query ReadParameter(
    $id: ID!
) {
    parameter(
        id: $id
    ) {
        id

        name(language: "en") {
            language
            text
        }

        deprecated

        tier
        ownTier

        group {
            id
            tier
            name {
                text
            }
        }
        sourceDefinition
    }
}
